(function (Drupal, once) {
  'use strict';

  const cleanupListeners = new WeakMap();

  Drupal.behaviors.authorsMobileMenu = {
    attach(context) {
      once(
        'authors-mobile-menu',
        '.view-authors.view-display-id-page_1 .vertical-tabs',
        context
      ).forEach((tabs) => {
        // Matches --tablet in variables.css and the detail scroll behavior.
        const mobileQuery = window.matchMedia('(width < 1024px)');
        const menu = tabs.querySelector('.vertical-tabs__menu');
        const panesContainer = tabs.querySelector('.vertical-tabs__panes');

        if (!menu || !panesContainer) {
          return;
        }
        tabs.classList.add('authors-accordion-ready');

        const items = Array.from(
          menu.querySelectorAll(':scope > .vertical-tabs__menu-item')
        );

        const panes = Array.from(
          panesContainer.querySelectorAll(':scope > .vertical-tabs__pane')
        );

        const ICON_DOWN = '#arrow_down';
        const ICON_UP = '#arrow_up';

        const paneById = new Map(panes.map((pane) => [pane.id, pane]));
        const links = new Map(items.map((item) => [
          item, item.querySelector(':scope > .vertical-tabs__menu-link'),
        ]));
        const itemPanes = new Map(items.map((item) => [
          item, paneById.get(links.get(item)?.getAttribute('aria-controls')),
        ]));
        const getLink = (item) => links.get(item);
        const getPane = (item) => itemPanes.get(item);

        const createIcon = () => {
          const namespace = 'http://www.w3.org/2000/svg';

          const svg = document.createElementNS(namespace, 'svg');
          const use = document.createElementNS(namespace, 'use');

          svg.classList.add('authors-mobile-menu-icon');
          svg.setAttribute('aria-hidden', 'true');
          svg.setAttribute('focusable', 'false');

          use.setAttribute('href', ICON_DOWN);

          svg.appendChild(use);

          return svg;
        };

        const setIconState = (item, open) => {
          const link = getLink(item);
          const use = link?.querySelector('.authors-mobile-menu-icon use');

          if (use) {
            use.setAttribute('href', open ? ICON_UP : ICON_DOWN);
          }
        };

        const prepareLinks = () => {
          items.forEach((item) => {
            const link = getLink(item);
            const pane = getPane(item);

            if (!link || !pane) {
              return;
            }

            link.setAttribute('aria-expanded', 'false');

            if (!link.querySelector('.authors-mobile-menu-icon')) {
              link.appendChild(createIcon());
            }
          });
        };

        const closeItem = (item) => {
          const link = getLink(item);
          const pane = getPane(item);

          if (!link || !pane) {
            return;
          }

          item.classList.remove('authors-mobile-menu-item--open');
          item.classList.remove('is-selected');

          pane.hidden = true;

          link.setAttribute('aria-expanded', 'false');
          link.setAttribute('aria-selected', 'false');
          link.setAttribute('tabindex', '0');

          setIconState(item, false);
        };

        const closeAll = (except = null) => {
          items.forEach((item) => {
            if (item !== except) {
              closeItem(item);
            }
          });
        };

        const openItem = (item) => {
          const link = getLink(item);
          const pane = getPane(item);

          if (!link || !pane) {
            return;
          }

          // Keep the clicked row at the same viewport position.
          const topBefore = item.getBoundingClientRect().top;

          closeAll(item);

          // Keep closed panels in their original container until first opened.
          if (pane.parentNode !== item) item.appendChild(pane);
          pane.hidden = false;

          item.classList.add('authors-mobile-menu-item--open');
          item.classList.add('is-selected');

          link.setAttribute('aria-expanded', 'true');
          link.setAttribute('aria-selected', 'true');
          link.setAttribute('tabindex', '0');

          setIconState(item, true);

          const topAfter = item.getBoundingClientRect().top;

          window.scrollBy({
            top: topAfter - topBefore,
            left: 0,
            behavior: 'instant',
          });
        };

        const restoreDesktopPanes = () => {
          if (panes.some((pane) => pane.parentNode !== panesContainer)) {
            const fragment = document.createDocumentFragment();
            panes.forEach((pane) => fragment.appendChild(pane));
            panesContainer.appendChild(fragment);
          }
        };

        const openHashItem = () => {
          if (!mobileQuery.matches || !window.location.hash) {
            return;
          }
          const item = items.find((item) => getLink(item)?.getAttribute('href') === window.location.hash);
          if (item) {
            openItem(item);
          }
        };

        const initializeMobile = () => {
          prepareLinks();
          items.forEach(closeItem);
          openHashItem();
        };

        const restoreDesktop = () => {
          restoreDesktopPanes();

          items.forEach((item) => {
            const link = getLink(item);

            item.classList.remove('authors-mobile-menu-item--open');

            if (link) {
              link.removeAttribute('aria-expanded');
            }
          });

          // Restore the original vertical-tabs state:
          // first selected tab open, all others hidden.
          let selectedItem =
            items.find((item) => item.classList.contains('is-selected')) ||
            items[0];

          items.forEach((item) => {
            const link = getLink(item);
            const pane = getPane(item);
            const selected = item === selectedItem;

            item.classList.toggle('is-selected', selected);

            if (pane) {
              pane.hidden = !selected;
            }

            if (link) {
              link.setAttribute(
                'aria-selected',
                selected ? 'true' : 'false'
              );

              link.setAttribute(
                'tabindex',
                selected ? '0' : '-1'
              );
            }
          });
        };

        const onClick = (event) => {
          if (!mobileQuery.matches) return;
          const link = event.target.closest('.vertical-tabs__menu-link');
          if (!link || !menu.contains(link)) return;
          const item = link.closest('.vertical-tabs__menu-item');
          if (!item) return;
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();
          if (item.classList.contains('authors-mobile-menu-item--open')) {
            closeItem(item);
          }
          else {
            openItem(item);
            history.replaceState(null, '', link.getAttribute('href'));
          }
        };
        menu.addEventListener('click', onClick, true);

        const onKeyDown = (event) => {
          if (!mobileQuery.matches) return;
          const link = event.target.closest('.vertical-tabs__menu-link');
          const current = items.indexOf(link?.closest('.vertical-tabs__menu-item'));
          if (current < 0) return;
          let next;
          switch (event.key) {
            case 'ArrowUp': case 'ArrowLeft': next = (current + items.length - 1) % items.length; break;
            case 'ArrowDown': case 'ArrowRight': next = (current + 1) % items.length; break;
            case 'Home': next = 0; break;
            case 'End': next = items.length - 1; break;
            default: return;
          }
          event.preventDefault();
          event.stopImmediatePropagation();
          openItem(items[next]);
          getLink(items[next]).focus();
          history.replaceState(null, '', getLink(items[next]).getAttribute('href'));
        };
        menu.addEventListener('keydown', onKeyDown, true);

        const updateLayout = (event) => {
          if (event.matches) {
            initializeMobile();
          }
          else {
            restoreDesktop();
          }
        };

        updateLayout(mobileQuery);

        mobileQuery.addEventListener('change', updateLayout);
        window.addEventListener('hashchange', openHashItem);
        cleanupListeners.set(tabs, () => {
          menu.removeEventListener('click', onClick, true);
          menu.removeEventListener('keydown', onKeyDown, true);
          mobileQuery.removeEventListener('change', updateLayout);
          window.removeEventListener('hashchange', openHashItem);
        });
      });
    },
    detach(context, settings, trigger) {
      if (trigger === 'unload') {
        once.remove('authors-mobile-menu', '.view-authors.view-display-id-page_1 .vertical-tabs', context).forEach((tabs) => {
          cleanupListeners.get(tabs)?.();
          cleanupListeners.delete(tabs);
        });
      }
    },
  };

})(Drupal, once);
